{
  "noResults": {
    "title": "Ingen eiendommer funnet",
    "description": "Fant ingen som matcher søkekriteriene dine. Prøv å justere søket"
  },
  "search": {
    "title": "Gjør et søk for å komme i gang",
    "description": "Bruk søkefunksjonen for å finne eiendommer. Du kan søke etter kommune eller kommunenummer, gårdsnummer og bruksnummer."
  }
}
